import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import Authenticator from './keycloak/Authenticator';
import config from './config';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';

import * as Sentry from '@sentry/browser';

const { keycloak } = config;
const store = configureStore();

Sentry.init({
  dsn: config.sentry.dsn,
  environment: config.sentry.state,
});

ReactDOM.render(
  <Provider store={store}>
    <Authenticator keycloakConfig={keycloak}>
      <App />
    </Authenticator>
  </Provider>,
  document.getElementById('app')
);
